export const onboardingKeys = {
    all: ['onboarding'] as const,
    status: () => ['onboarding', 'status'] as const,
    wizard: () => ['onboarding', 'wizard'] as const,
    testLeadTrace: (contactId: string) => ['onboarding', 'test-lead', contactId] as const,
} as const;
